import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import classes from "./blog.module.css";
import Footer from "../../components/footer";
import { blogPosts } from "../../data/blogPosts";

const BlogTag = () => {
  const { tag } = useParams();

  // Format the tag for display (replace hyphens with spaces, capitalize)
  const formattedTag = tag
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  // Filter posts by this tag
  const filteredPosts = blogPosts.filter(
    (post) =>
      post.tags &&
      post.tags.some(
        (postTag) => postTag.toLowerCase() === formattedTag.toLowerCase()
      )
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className={classes.blogContainer}>
        {/* Tag Header */}
        <div className={classes.categoryHeader}>
          <div className={classes.breadcrumbs}>
            <Link to="/" className={classes.breadcrumbLink}>
              Home
            </Link>
            <span className={classes.breadcrumbSeparator}>/</span>
            <Link to="/blog" className={classes.breadcrumbLink}>
              Blog
            </Link>
            <span className={classes.breadcrumbSeparator}>/</span>
            <span className={classes.breadcrumbCurrent}>
              Tag: {formattedTag}
            </span>
          </div>

          <h1 className={classes.categoryTitle}>
            <span className={classes.tagPrefix}>Tag:</span> {formattedTag}
          </h1>
          <p className={classes.categoryDescription}>
            Browse our collection of articles tagged with "{formattedTag}"
          </p>
        </div>

        {/* Blog Listings */}
        <div className={classes.contentSection}>
          {filteredPosts.length > 0 ? (
            <div className={classes.blogGrid}>
              {filteredPosts.map((post) => (
                <div key={post.id} className={classes.blogCard}>
                  <Link to={`/blog/${post.slug}`} className={classes.blogLink}>
                    <div className={classes.blogImageContainer}>
                      {post.image ? (
                        <img
                          src={post.image}
                          alt={post.title}
                          className={classes.blogImage}
                        />
                      ) : (
                        <div className={classes.blogImagePlaceholder}></div>
                      )}
                      <div className={classes.categoryLabel}>
                        {post.category}
                      </div>
                    </div>
                    <div className={classes.blogContent}>
                      <h3 className={classes.blogTitle}>{post.title}</h3>
                      <div className={classes.blogMeta}>
                        <span>by {post.author}</span>
                        <span> | </span>
                        <span>{post.date}</span>
                      </div>
                      <p className={classes.blogExcerpt}>{post.excerpt}</p>
                      <span className={classes.readMore}>Read More</span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <div className={classes.noResults}>
              <h3>No articles found with this tag</h3>
              <p>We couldn't find any articles tagged with "{formattedTag}".</p>
              <Link to="/blog" className={classes.browseAllButton}>
                Browse All Articles
              </Link>
            </div>
          )}
        </div>

        <div className={classes.relatedTagsSection}>
          <p className={classes.relatedTxt}>Related Tags</p>
          <div className={classes.relatedTags}>
            {/* Get all tags excluding the current one */}
            {Array.from(
              new Set(
                blogPosts
                  .flatMap((post) => post.tags || [])
                  .filter((t) => t.toLowerCase() !== formattedTag.toLowerCase())
              )
            )
              .slice(0, 6)
              .map((relatedTag) => (
                <Link
                  key={relatedTag}
                  to={`/blog/tag/${relatedTag
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  className={classes.relatedTag}
                >
                  {relatedTag}
                </Link>
              ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogTag;
